import React, { useState, useEffect } from 'react';
import CommonServices from '../../services/ComanServices';
import useAsync from '../../hooks/useAsync';

// Index % / Stock %: one entry. Created once (POST), then always edited (PUT).
function Percentage() {
  const { data, error, loading } = useAsync(CommonServices.getPercentage);

  const [exists, setExists] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formValues, setFormValues] = useState({
    indexPercent: '',
    stockPercent: '',
  });

  useEffect(() => {
    if (data?.data) {
      setExists(true);
      setFormValues({
        indexPercent: data.data.index_percent ?? data.data.indexPercent ?? '',
        stockPercent: data.data.stock_percent ?? data.data.stockPercent ?? '',
      });
    }
  }, [data]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      indexPercent: Number(formValues.indexPercent),
      stockPercent: Number(formValues.stockPercent),
    };
    setSaving(true);
    try {
      if (exists) {
        await CommonServices.updatePercentage(payload);
        alert('Index % and Stock % updated successfully');
      } else {
        await CommonServices.createPercentage(payload);
        setExists(true);
        alert('Index % and Stock % created successfully');
      }
    } catch (err) {
      // Created meanwhile (e.g. in another tab): switch to editing.
      if (err?.response?.status === 409) setExists(true);
      console.error('Failed to save Index % / Stock %', err);
      alert(err?.response?.data?.message || 'Failed to save Index % / Stock %');
    } finally {
      setSaving(false);
    }
  };

  // Messages inside the page area (a bare div sits under the fixed admin header / sidebar).
  if (loading || error) {
    return (
      <div className="right_col" role="main">
        <div className="title-box">
          <h2>Index &amp; Stock %</h2>
        </div>
        <div className="container-box px-5">
          <div className="container-box-inner">
            <p>{loading ? 'Loading...' : 'Error loading Index % / Stock %. Please try again.'}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Index &amp; Stock %</h2>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Index %</label>
                    <input
                      type="number"
                      name="indexPercent"
                      className="form-control"
                      value={formValues.indexPercent}
                      onChange={handleInputChange}
                      required
                      min={0}
                      max={100}
                      step="0.01"
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Stock %</label>
                    <input
                      type="number"
                      name="stockPercent"
                      className="form-control"
                      value={formValues.stockPercent}
                      onChange={handleInputChange}
                      required
                      min={0}
                      max={100}
                      step="0.01"
                    />
                  </div>
                </div>
              </div>
              <button type="submit" className="submit-green-btn" disabled={saving}>
                {exists ? 'UPDATE' : 'CREATE'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Percentage;
